export const UI_PORT = 3015;
export const CONTEXT_PATH = '/console/doc/v1';
export const API_PATH = ' ';
export const API_URL = API_PATH + '/doc/v1';
export const SERVICE_ID = 'hyper-doc';

export const BUILD_TAG = 'v1.1.13';

export const BUILD_DATE = 'Sun Sep 15 16:13:40 UTC 2024';

export const BUILD_COMMIT = 'f7d2f3c5b97f6d0cf83b7e316e6044b806e7c1e7';
